export const animationDuration = '300ms';
export const animationDelay = '350ms';
export const animationLongDelay = '2s';
export const EASE = '300ms ease-in-out';
